import React, { useEffect, useRef } from "react";
import { Nav } from "../../layouts/navbar/nav";
import images from "../../constant/images";
import videos from "../../constant/videos";
// import Footer from "../../layouts/footer/footer";

export const HomePage = () => {


  return (
    <div className="flex flex-col min-h-screen relative overflow-hidden">
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src={videos.homepage} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Optional Overlay */}
      {/* <div className="absolute inset-0 bg-black/30 z-0"></div> */}

      {/* Foreground Content */}
      <div className="relative z-10 flex flex-col min-h-screen">
        <div>
          <Nav />
        </div>
        <main className="flex flex-col items-center justify-center pt-24 sm:pt-32">
          <h1 className="text-white font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl custom-font text-center" style={{ textShadow: "6px 6px 7px #000" , fontWeight: '900' }}>
            When You Know You Know
          </h1>
        </main>
      </div>
    </div>
  );
};